// extracted by mini-css-extract-plugin
export default {"wrapper":"PlusMinus_wrapper__+bKQP","circle":"PlusMinus_circle__gWgqL"};